/**
 * @file auth.config.js
 * @description Centralized authentication configuration.
 * All auth-related constants live here — no scattered magic strings.
 */

export const AUTH_SCOPES = [
  'openid',
  'profile',
  'https://CentAIT.onmicrosoft.com/webapp-idp-dev/api.read',
  'offline_access',
];

export const TOKEN_REFRESH_BUFFER_MS = 15 * 60 * 1000; // 15 min before expiry
export const IDLE_LOGOUT_MS = 45 * 60 * 1000;           // 45 min idle
export const TOKEN_MIN_VALID_MS = 5 * 60 * 1000;        // Must be valid ≥ 5 min
export const TOKEN_NEAR_EXPIRY_MS = 20 * 60 * 1000;     // "Close to expiry" threshold
export const FETCH_PROFILE_DELAY_MS = 300;               // Small delay after login event